/**
 * Family Service
 *
 * Exposes the app-wide {@link IFamilyService} instance — Supabase is the only
 * implementation (mock mode was removed app-wide).
 *
 * @module features/family/services/familyService
 */

import type { IFamilyService } from './familyService.types';
import { SupabaseFamilyService } from './supabaseFamilyService';

export type { IFamilyService } from './familyService.types';

export const familyService: IFamilyService = new SupabaseFamilyService();
